import { useEffect, useState } from 'react';
import apiClient from '@/utils/api';
import { TASK_ROLES, MANAGEMENT_ROLES } from '@/utils/navigation';

export const useTaskBadge = (user, pathname) => {
  const [counts, setCounts] = useState({ open: 0, overdue: 0 });
  useEffect(() => {
    let active = true;
    setCounts({ open: 0, overdue: 0 });
    if (!TASK_ROLES.includes(user?.role)) return;
    const load = async () => {
      try {
        const { data } = await apiClient.get('/tasks/count', { params: { scope: MANAGEMENT_ROLES.includes(user.role) ? 'all' : 'mine' } });
        if (active) setCounts(data.counts);
      } catch { if (active) setCounts({ open: 0, overdue: 0 }); }
    };
    load(); const timer = setInterval(load, 60000);
    window.addEventListener('tasks-changed', load);
    return () => { active = false; clearInterval(timer); window.removeEventListener('tasks-changed', load); };
  }, [user?.id, user?.role, pathname]);
  return counts;
};